export interface Category {
  key: string;
  url: string;
  img: string;
}

export const categories: Category[] = [
  {
    key: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Pair%20of%20white%20and%20red%20leather%20sneakers%20on%20warm%20sand%20colored%20surface%20with%20palm%20leaf%20shadow%2C%20bright%20airy%20product%20photography%2C%20crisp%20details&width=400&height=400&seq=cat-shoes-02&orientation=squarish&nocache=true',
  },
  {
    key: 'hoodiesSweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Sage%20green%20oversized%20hoodie%20folded%20on%20light%20wooden%20bench%20against%20cream%20wall%2C%20soft%20morning%20light%2C%20cozy%20minimal%20fashion%20photography&width=400&height=400&seq=cat-hoodie-02&orientation=squarish&nocache=true',
  },
  {
    key: 'tShirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Black%20graphic%20t-shirt%20hanging%20on%20wooden%20hanger%20against%20light%20gray%20concrete%20wall%2C%20urban%20streetwear%20aesthetic%2C%20soft%20diffused%20light%2C%20editorial%20product%20shot&width=400&height=400&seq=cat-tshirt-02&orientation=squarish&nocache=true',
  },
  {
    key: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Tan%20bomber%20jacket%20laid%20flat%20on%20rust%20colored%20textured%20fabric%20background%2C%20autumn%20tones%2C%20soft%20natural%20light%2C%20minimal%20fashion%20photography&width=400&height=400&seq=cat-jacket-02&orientation=squarish&nocache=true',
  },
  {
    key: 'pantsShorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Blue%20denim%20cargo%20pants%20folded%20neatly%20on%20white%20linen%20backdrop%2C%20bright%20clean%20product%20photography%2C%20sharp%20texture%20detail%2C%20minimal%20styling&width=400&height=400&seq=cat-pants-02&orientation=squarish&nocache=true',
  },
  {
    key: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Black%20and%20white%20snapback%20cap%20on%20pastel%20yellow%20background%20with%20soft%20shadow%2C%20playful%20minimal%20product%20photography%2C%20clean%20composition&width=400&height=400&seq=cat-headwear-02&orientation=squarish&nocache=true',
  },
  {
    key: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Charcoal%20grey%20matching%20tracksuit%20set%20displayed%20on%20light%20beige%20background%2C%20athleisure%20style%2C%20soft%20studio%20lighting%2C%20minimal%20fashion%20photography&width=400&height=400&seq=cat-sets-02&orientation=squarish&nocache=true',
  },
  {
    key: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Set%20of%20folded%20cotton%20boxer%20briefs%20in%20neutral%20tones%20arranged%20on%20light%20gray%20surface%2C%20clean%20minimal%20flat%20lay%2C%20soft%20even%20lighting&width=400&height=400&seq=cat-underwear-02&orientation=squarish&nocache=true',
  },
  {
    key: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Red%20sports%20jersey%20hanging%20on%20rack%20against%20white%20stadium%20inspired%20wall%2C%20athletic%20product%20photography%2C%20vivid%20color%2C%20clean%20minimal%20background&width=400&height=400&seq=cat-jersey-02&orientation=squarish&nocache=true',
  },
  {
    key: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Silver%20watch%20and%20sunglasses%20arranged%20on%20dark%20green%20velvet%20surface%2C%20luxury%20accessory%20flat%20lay%2C%20soft%20dramatic%20lighting%2C%20editorial%20photography&width=400&height=400&seq=cat-accessories-02&orientation=squarish&nocache=true',
  },
  {
    key: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Black%20nylon%20crossbody%20bag%20on%20light%20concrete%20surface%20against%20minimal%20wall%2C%20urban%20streetwear%20accessory%2C%20soft%20natural%20light%2C%20clean%20product%20shot&width=400&height=400&seq=cat-bags-02&orientation=squarish&nocache=true',
  },
  {
    key: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Brown%20leather%20belt%20coiled%20with%20metal%20buckle%20on%20warm%20beige%20linen%20background%2C%20luxury%20accessory%20photography%2C%20soft%20lighting%2C%20minimal%20styling&width=400&height=400&seq=cat-belts-02&orientation=squarish&nocache=true',
  },
  {
    key: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20on%20white%20marble%20surface%20with%20soft%20bokeh%20background%2C%20luxury%20fragrance%20product%20photography%2C%20warm%20golden%20light&width=400&height=400&seq=cat-perfumes-02&orientation=squarish&nocache=true',
  },
  {
    key: 'otherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Curated%20flat%20lay%20of%20mixed%20streetwear%20items%20including%20socks%20phone%20case%20and%20keychain%20on%20light%20neutral%20background%2C%20minimal%20editorial%20photography&width=400&height=400&seq=cat-other-02&orientation=squarish&nocache=true',
  },
];